import template from './column-grid.jade';
import validation from '../../../services/validation';
import { patterns } from '../../../services/validationPatterns';

export default angular.module('cian.addForm.columnGrid', []).directive('cianAfAboutObjectColumnGrid', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'deviceService',
    function (deviceService) {
      this.isMobile = deviceService.isMobile;
      this.pattern = patterns.columnGrid;

      this.validation = validation(this.form, 'columnGrid', {
        pattern: 'Введите числа как указано в примере: 3x3',
      });
    },
  ],
  controllerAs: 'columnGrid',
  template,
})).name;
